module.exports = __webpack_public_path__ + "img/pmt.fcf4efc2.jpg";